import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import IndexFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/index/IndexFormHandler';
import ClientFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/client/ClientFormHandler';
import ClientAddressFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/clientAddress/AddressFormHandler';
import CorrespondanceAddressFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/correspondanceAddress/CorrespondanceFormHandler';
import LanguageFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/language/LanguageFormHandler';
import AssetsFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/assetsAndIncome/assets/AssetsFormHandler';
import IncomeFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/assetsAndIncome/income/IncomeFormHandler';
import ExceptionalDebitFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/exceptionalDebit/ExceptionalDebitFormHandler';
import DocumentsFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/documents/DocumentsFormHandler';
import PrepaidProductFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/prepaidProduct/PrepaidProductFormHandler';


export default function PrepaidApplication() {
  return (
    <>
      <CC.Box mb={10}>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Demande prépayée
        </CC.Text>
        <IndexFormHandler />
      </CC.Box>
      <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Client</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Co-client</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Addresse Client</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Addresse Correspondance</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Langage</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Bien et Revenus</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Débit Exceptionnel</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Documents</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Produit prépayé</CC.Tab>
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <ClientFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <CC.Text my={10}> Interface non disponible</CC.Text>
        </CC.TabPanel>
        <CC.TabPanel>
          <ClientAddressFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <CorrespondanceAddressFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <LanguageFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <AssetsFormHandler />
          <IncomeFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <ExceptionalDebitFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <DocumentsFormHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <PrepaidProductFormHandler />
        </CC.TabPanel>

      </CC.TabPanels>
    </CC.Tabs>
    </>
  );
  
}